/**
 * Billing tooltip copy — the one home for the explanations behind the overtime
 * and convenience-fee info icons (GOTU-19712).
 *
 * The wording is the office's billing terms, so it must not fork: every screen
 * that explains these charges imports it from here and none declares its own.
 */

/** Copy behind the overtime row's info icon: why overtime is charged at 1.5x. */
export const OVERTIME_INFO =
  'Overtime pay (1.5x rate) is required for hours that exceed the state’s daily and/or weekly regular working hour limits.';

/** Copy behind the convenience-fee row's info icon: the card fee and how to avoid it. */
export const CONVENIENCE_FEE_INFO =
  'GoTu charges a 3.5% convenience fee on Credit Card transactions. If you do not wish to be charged the convenience fee, please update your billing to E-check/ACH.';
